export default __webpack_public_path__ + "static/media/img1.fe00370c.png";